import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router, ActivatedRoute, NavigationEnd, ActivationEnd } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { map, filter } from 'rxjs/operators';
import * as $ from 'jquery';
import { AppServiceService } from './../../app/main/services/product.service';
import { MainMenuService } from './../../app/main/services/menuservice.service';
import { HotkeysService, Hotkey } from 'angular2-hotkeys';
import Swal from 'sweetalert2';
import { json } from 'ngx-custom-validators/src/app/json/validator';
import { Subscription } from 'rxjs';
import { UtilityService } from "../../app/shared/services/Utility.service";
@Component({
    selector: 'navbar',
    template: require('./navbar.html'),
})
export class NavbarComponent implements OnInit {

    isCollapsed = true;
    menu = [{
        title: 'Home',
        'link': '/home',
    }, {
        title: 'About Us',
        'link': '/aboutus',
    }];
    Router;
    isAdmin;
    isLoggedIn;
    currentUser = {};
    AuthService;
    UserId: any = 0;
    UnitId: any = 0;
    CurrentFYear: any = 0;
    id_token: any = '';
    public myText: any;
    private userObj: any;
    private type: any;
    public breadcrumbList: Array<any> = [];
    ApiBusy: Subscription;
    public dataTitle: any;
    public GATEINWARDENTRY: any = 0;

    swalWithBootstrapButtons = Swal.mixin({
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        buttonsStyling: false,
    });

    toast = Swal.mixin({
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: 3000,
        backdrop: `rgba(30, 30, 37, 0.4)`
    });

    toastWarningMsg(options) {
        if (typeof (options) == "object") {
            this.toast({
                type: 'warning',
                showConfirmButton: options.confirm_btn,
                timer: options.timer,
                title: options.msg
            });
        } else {
            this.toast({
                type: 'warning',
                title: options
            });
        }
    }

    static parameters = [AuthService, Router, ActivatedRoute, AppServiceService, HotkeysService, HttpClient, MainMenuService, UtilityService];
    constructor(private authService: AuthService, private router: Router, private activatedRoute: ActivatedRoute, private service: AppServiceService, private hotkeysService: HotkeysService, private http: HttpClient, private menuService: MainMenuService, public utilityService: UtilityService) {
        this.http = http;
        this.AuthService = authService;
        this.hotkeysService = hotkeysService;
        this.Router = router;
        this.activatedRoute = activatedRoute;
        this.service = service;
        var Permission = JSON.parse(localStorage.getItem('permission'));
        // this.menuService.getMenus(Permission);
        this.reset();
        this.AuthService.currentUserChanged.subscribe(user => {
            this.currentUser = user;
            this.reset();
        });


        // <div class="modal-backdrop fade show"></div>
        // $("div.modal-backdrop.fade.show").remove();
        this.Router.events.pipe(
            filter((event, router) => event instanceof ActivationEnd && event.snapshot.children.length == 0))
            .subscribe((event: ActivationEnd, router: any) => {
                this.dataTitle = event.snapshot.data;
                $("div.modal-backdrop.fade.show").remove();
                this.Router.events.subscribe((router: any) => {
                    let routerUrl: string, routerList: Array<any>;
                    routerUrl = router.urlAfterRedirects;
                    if (routerUrl && typeof routerUrl === 'string') {
                        this.breadcrumbList.length = 0;
                        routerList = routerUrl.slice(1).split('/');
                        var filtered = routerList.filter(function (item) {
                            return !(parseInt(item) == item);
                        });
                        filtered.forEach((router, index, path) => {
                            this.breadcrumbList.push({
                                name: router,
                                path: routerUrl,
                                title: this.dataTitle.title,
                                maintitle: this.dataTitle.maintitle
                            });
                        });
                    }
                });
            });
        this.InitHotKeys();
    }

    InitHotKeys() {
        this.hotkeysService.add(new Hotkey('alt+h', (event: KeyboardEvent): boolean => {
            this.CommonNavgator('H00');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']));

        this.hotkeysService.add(new Hotkey('alt+m', (event: KeyboardEvent): boolean => {
            this.CommonNavgator('M00');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']));

        this.hotkeysService.add(new Hotkey('alt+p', (event: KeyboardEvent): boolean => {
            this.CommonNavgator('P00');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']));

        // this.hotkeysService.add(new Hotkey('alt+s', (event: KeyboardEvent): boolean => {
        //     this.CommonNavgator('S00');
        //     return false; // Prevent bubbling
        // }, ['INPUT', 'SELECT', 'TEXTAREA']));

        this.hotkeysService.add(new Hotkey('alt+f', (event: KeyboardEvent): boolean => {
            this.CommonNavgator('F00');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']));

        this.hotkeysService.add(new Hotkey('alt+t', (event: KeyboardEvent): boolean => {
            this.CommonNavgator('T00');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']));

        this.hotkeysService.add(new Hotkey('alt+r', (event: KeyboardEvent): boolean => {
            this.CommonNavgator('R00');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']));

        this.hotkeysService.add(new Hotkey('f5', (event: KeyboardEvent): boolean => {
            // $('button[type=button]#pending_order').click();
            this.reloadBrowser();
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']));

        this.hotkeysService.add(new Hotkey('ctrl+f5', (event: KeyboardEvent): boolean => {
            // $('button[type=button]#pending_order').click();
            this.reloadBrowser();
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']));

        this.hotkeysService.add(new Hotkey('ctrl+r', (event: KeyboardEvent): boolean => {
            // $('button[type=button]#pending_order').click();
            this.reloadBrowser();
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']));

        this.hotkeysService.add(new Hotkey('ctrl+shift+i', (event: KeyboardEvent): boolean => {
            this.CommonWindowNavgator('S03');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']));

        this.hotkeysService.add(new Hotkey('ctrl+shift+g', (event: KeyboardEvent): boolean => {
            this.CommonWindowNavgator('P03');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']));

        const ctrlz = new Hotkey('ctrl+z', (event: KeyboardEvent): boolean => {
            this.launchCalc();
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        //this.hotkeyList.push(ctrlz);
        this.hotkeysService.add(ctrlz);
    }

    CommonNavgator(MoveCode) {
        /* let Menu = this.menuService.GetPageNavigationURL(MoveCode);
        if(!Menu){
            return false;
        }
        this.router.navigateByUrl(Menu); */
        let Menu1 = this.menuService.GetPageNavigationURL(MoveCode);
        if (!Menu1) {
            return false;
        }
        let URL = window.location.pathname;
        //return;

        if (Menu1 != URL) {
            Swal({
                html: 'Do you want to exit current page',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Continue',
                customClass: 'swal-warning-custom',
            }).then(choice => {
                if (choice.value) {
                    let Menu = this.menuService.GetPageNavigationURL(MoveCode);
                    if (!Menu) {
                        return false;
                    }
                    this.router.navigateByUrl(Menu);
                } else {
                    //$('#ItemDiscount').prop('disabled', false);
                }
            });
        } else {
            let Menu = this.menuService.GetPageNavigationURL(MoveCode);
            if (!Menu) {
                return false;
            }
            this.router.navigateByUrl(Menu);
        }
    }

    CommonWindowNavgator(MoveCode) {
        let Menu = this.menuService.GetPageNavigationURL(MoveCode);
        if (!Menu) {
            return false;
        }
        window.open(Menu);
    }

    per: any;
    ngOnInit() {
        let parent = this;
        document.addEventListener("visibilitychange", function (event) {
            if (!document.hidden) {
                if (parent.UserId == 0 && parent.UnitId == 0 && parent.CurrentFYear == 0) {
                    return false;
                }
                let Permission = JSON.parse(localStorage.getItem('permission'));
                if (Permission && Permission.length > 0) {
                    if (parent.UserId != Permission[0]["_id"] || parent.UnitId != Permission[0]["Unit_ID"] || parent.CurrentFYear != Permission[0]["CurrentFYear"]) {
                        // || parent.id_token != localStorage.getItem('id_token')
                        window.location.reload();
                    }
                }
            }
        });

        this.GATEINWARDENTRY = 0;
        var SystemConfigDetails_1;
        SystemConfigDetails_1 = JSON.parse(localStorage.getItem('SystemConfigDetails'));
        /* var GATEINWARDENTRY = SystemConfigDetails_1.filter(function (item) {
            return item.Config_Name === 'ENABLE GATE INWARD ENTRY'
        });

        this.GATEINWARDENTRY = this.f_ChkNum(GATEINWARDENTRY.length > 0 ? GATEINWARDENTRY[0].Config_Value : 0); */
        
        setTimeout(() => {
            if (localStorage.getItem("permission")) {
                this.per = JSON.parse(localStorage.getItem('permission'))[0];
                if (this.per.colorTheme !== undefined && this.per.colorTheme !== '') {
                    $('body').addClass(this.per.colorTheme);
                }
                if (this.per.fontTheme !== undefined && this.per.fontTheme !== '') {
                    $('body').addClass(this.per.fontTheme);
                }
                this.service.getFooterDetails();
            }



            $(document).ready(function () {
                // $(window).on("unload", function(e) {
                //     //alert("call");
                //     localStorage.removeItem('id_token');
                //     localStorage.removeItem('user');
                //     localStorage.removeItem('permission');
                // });

                $(".dropdown").on("show.bs.dropdown", function (e) {
                    $(this)
                        .find(".dropdown-menu")
                        .first()
                        .stop(true, true)
                        .slideDown(400);
                });
                $(".dropdown").on("hide.bs.dropdown", function (e) {
                    $(this)
                        .find(".dropdown-menu")
                        .first()
                        .stop(true, true)
                        .slideUp(300);
                });

                $("a").tooltip();



                /* $('ul.navbar-nav>li.dropdown, ul.navbar-nav>li.dropdown>ul.dropdown-menu>li.dropdown-submenu').mouseenter(function () {
                    // $(this).find('.dropdown-menu').first().stop(true, true).delay(50).fadeIn(180);
                    $(this).find('.dropdown-menu').first().stop(true, true).delay(100).fadeIn(180);
                });

                $('ul.navbar-nav>li.dropdown, ul.navbar-nav>li.dropdown>ul.dropdown-menu>li.dropdown-submenu').mouseleave(function () {
                    // $(this).find('.dropdown-menu').first().show().delay(50).fadeOut(180);
                    $(this).find('.dropdown-menu').first().show().fadeOut(100);
                    //$( ".dropdown-menu" ).show().delay(100).fadeOut();
                }); */

            });

            // this.service.getter();
            // this.service.manufacturergetter();
            // this.service.brandgetter();
            // this.service.currentTable.subscribe(res=> {
            //     if (res.toString() == 'default') {
            //         this.service.getter();
            //     }
            // });
        }, 500);
        //this.CloseTabBrowser();
        // var Permission = JSON.parse(localStorage.getItem('permission'));
        // this.getMenus(Permission);

        // this.menuService.MenuListmyMethodSubject.subscribe(response => {
        //     var SystemConfigDetails;
        //     const localStorageItem = localStorage.getItem('SystemConfigDetails');
        //     SystemConfigDetails = localStorageItem ? JSON.parse(localStorageItem) : [];
        //     var costCenter = SystemConfigDetails.filter(function (item) {
        //         return item.Config_Name === 'COST CENTER MODULE'
        //     });
        //     // console.log("response", response);
        //     if (costCenter.length > 0 && costCenter[0].Config_Value === '0') {
        //         response = response.filter(function (item) {
        //             return (item['parent_id'] !== 'F18') && (item['parent_id'] !== 'F25') && (item['parent_id'] !== 'F26') && (item['parent_id'] !== 'FC12') && (item['parent_id'] !== 'FC13') && (item['parent_id'] !='CCS0') && (item['parent_id'] != 'FC15');
        //         });
        //         this.allMenus = response;
        //     } else {
        //         this.allMenus = response;
        //     }
        // });
        this.menuService.MenuListmyMethodSubject.subscribe(response => {
            this.authService.systemConfigDetails$.subscribe(SystemConfigDetails => {
                const costCenter = SystemConfigDetails.find(item => item.Config_Name === 'COST CENTER MODULE');
                const enableBatchCreation = SystemConfigDetails.find(item => item.Config_Name === 'Enable Batch Creation');

                const excludedIds = new Set();
                if (costCenter && costCenter.Config_Value === '0') {
                    ['F18', 'F25', 'F26', 'FC12', 'FC13', 'CCS0', 'FC15'].forEach(id => excludedIds.add(id));
                }

                if (enableBatchCreation && enableBatchCreation.Config_Value === '0') {
                    excludedIds.add('P24');
                }
                this.allMenus = response.filter(item => !excludedIds.has(item.parent_id));
            });
        });
        this.menuService.UserPermissionmyMethodSubject.subscribe(Permission => {
            if (Permission.length == 0) {
                return false;
            }
            this.UserId = Permission[0]["_id"];
            this.UnitId = Permission[0]["Unit_ID"];
            this.CurrentFYear = Permission[0]["CurrentFYear"];
            this.id_token = localStorage.getItem('id_token');
        })
    }

    public allMenus: any = [];
    updatefirstletter(val, id) {
        // debugger
        var i = 0;
        if (val == 'Payroll') {
            i = val.toString().indexOf('y');
        }
        if (i == 0) {
            $('#first_' + id).text('');
            $('#second_' + id).text(val[i]);
            $('#third_' + id).text(val.substring(i + 1, val.length));
        } else {
            $('#first_' + id).text(val.substring(0, i));
            $('#second_' + id).text(val[i]);
            $('#third_' + id).text(val.substring(i + 1, val.length));
        }
        return '';
    }

    reset() {
        this.userObj = {};
        this.type = {};
        this.AuthService.isLoggedIn().then(is => {
            this.isLoggedIn = is;
            // this.isLoggedIn? this.Router.navigateByUrl('/home') : this.Router.navigateByUrl('/login');
        });
        this.AuthService.isAdmin().then(is => {
            this.isAdmin = is;
        });
        this.AuthService.getCurrentUser().then(user => {
            this.currentUser = user;
        });
        setTimeout(() => {
            if (localStorage.getItem('user') && localStorage.getItem('permission')) {
                this.userObj = JSON.parse(localStorage.getItem('user'));
                this.type = JSON.parse(localStorage.getItem('permission'))[0];
            }
        }, 1000);
    }

    logout() {
        // alert("logout");
        var per = JSON.parse(localStorage.getItem('permission'))[0];
        this.http.post('/api/users/RemoveLoggedInTime', { "UserId": per["_id"] })
            .subscribe(response => {
                return this.AuthService.logout().then(() => {
                    this.Router.navigateByUrl('/login');
                    localStorage.clear();
                    this.reset();
                    this.service.getFooterDetails();
                    this.service.footerDataSubject.next(null);
                    this.service.OnDashboardDataLoad();
                    setTimeout(() => {
                        this.service.footerDataTable.subscribe(res => {
                            this.per = res;
                        });
                    }, 600);
                });
            });
    }
    onCostCentreSummaryReport() {
        let baseurl = window.location.origin;
        let redirectPath ='';
        console.log(baseurl);
        if (baseurl.includes('localhost:8080')) {
            redirectPath = 'http://localhost:4200';
        } else if (baseurl.includes('https://erpperftesting.enterodirect.com')) {
            redirectPath = 'https://dynamic-reporttest.enterodirect.com';
        } else if (baseurl.includes('https://erpdevelopment.enterodirect.com')){
            redirectPath = 'https://dynamic-reportdev.enterodirect.com';
        }else{
            redirectPath = 'https://dynamic-report.enterodirect.com';
        }
        let token = localStorage.getItem('id_token');
        let userinfo = JSON.parse(localStorage.getItem('permission'))[0] || {};
        // http://localhost:4200/
        let payload = { token, baseurl, "Company_Name": userinfo.Company_Name, "Unit_Name": userinfo.Unit_Name, "Unit_ID": userinfo.Unit_ID, "Company_ID": userinfo.Company_ID, "CurrentFYear": userinfo.CurrentFYear, "Login_Name": userinfo.Login_Name, "Fyear_FromDate": userinfo.Fyear_FromDate, "Fyear_ToDate": userinfo.Fyear_ToDate, "Unit_GST_No": userinfo.Unit_GST_No, }
        window.open(redirectPath+'/?payload=' + encodeURIComponent(JSON.stringify(payload)) + '&path=' + 'report', '_blank',);
    }
    reloadBrowser() {
        Swal({
            title: 'Reload Window?',
            text: "All the changes will be lost!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirm',
            customClass: 'swal-warning-custom'
        }).then(result => {
            if (result.value) {
                location.reload();
            }
            return;
        });
    }

    launchCalc() {
        // var WshShell = new ActiveXObject("WScript.Shell");
        // WshShell.Run("calc.exe");
        window.open('Calculator:///');
    }

    /*   CloseTabBrowser(){

          window.addEventListener("beforeunload", function (e) {
              if(e.type = "beforeunload")(){

              }
              var confirmationMessage = "\o/";
              alert("exit");
              (e || window.event).returnValue = confirmationMessage; //Gecko + IE
              return confirmationMessage;                            //Webkit, Safari, Chrome
          });
      } */

    OnEInvoiceClick() {
        var unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
        var Data = {
            Company_ID: unitInfo.Company_ID,
            Unit_ID: unitInfo.Unit_ID,
            CreatedBy: unitInfo._id
        };
        this.ApiBusy = this.http.post('/api/users/EInvoice_GetUserDetail', Data)
            .subscribe((response: any) => {
                if (response.length == 0) {
                    return false;
                } else if ((response[0]["msg"] ? response[0]["msg"] : "").length > 0) {
                    this.toastWarningMsg(response[0]["msg"]);
                    return false;
                } else if ((response[0]["EInvoice_Comp_Code"] ? response[0]["EInvoice_Comp_Code"] : "").length == 0) {
                    this.toastWarningMsg("Company is not registered for E-Invoice.");
                    return false;
                }
                var userModel = {
                    Company_ID: unitInfo.Company_ID,
                    Unit_ID: unitInfo.Unit_ID,
                    UserName: response[0]["UserName"],
                    Password: response[0]["Password"],
                    FYear: unitInfo.CurrentFYear,
                    EInvoice_Comp_Code: response[0]["EInvoice_Comp_Code"]
                };
                const myform = document.createElement('form');
                myform.id = "E-Sale-Invoice-Form";
                myform.method = 'POST';
                myform.action = response[0]["EInvoice_URL"] + "/Login/Index";
                myform.target = "_blank";
                myform.style.display = 'none';
                var modelKeys = Object.keys(userModel);
                modelKeys.forEach(elem => {
                    const mapInput = document.createElement('input');
                    mapInput.type = 'hidden';
                    mapInput.name = elem;
                    mapInput.value = userModel[elem];
                    myform.appendChild(mapInput);
                });
                document.body.appendChild(myform);
                myform.submit();
                myform.remove();
            });
    }

    OnSalesOrderToInvoiceClick() {
        var unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
        var Data = {
            Name: unitInfo.Login_Name,
        };
        this.ApiBusy = this.http.post(`/api/${unitInfo.Company_Code}/products/ValidateOpenSalesOrderToInvoice`, Data)
            .subscribe((response: any) => {

                if (response[0].flag == 0) {
                    this.toastWarningMsg(response[0].msg);
                }
                else {
                    this.router.navigateByUrl('/sales/salesordertochallan')
                }
            })
    }

    OnMCRClick() {
        var unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
        var Data = {
            Name: unitInfo.Login_Name,
        };
        this.ApiBusy = this.http.post(`/api/${unitInfo.Company_Code}/products/ValidateOpenMCR`, Data)
            .subscribe((response: any) => {

                if (response[0].flag == 0) {
                    this.toastWarningMsg(response[0].msg);
                }
                else {
                    this.router.navigateByUrl('/finances/salesmanreceipt');
                }
            })
    }

    unitInfo: any;
    CommonReport_Login_Link: any;
    OnCommonReportClick() {
        this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
        if ("SystemConfigDetails" in localStorage) {
            var data = JSON.parse(localStorage.getItem('SystemConfigDetails'))
            var CommonReport_Login_Link = data.filter(function (item) {
                return item.Config_Name === 'CommonReport_Login_Link'
            });
            this.CommonReport_Login_Link = (CommonReport_Login_Link.length > 0 ? CommonReport_Login_Link[0].Config_Value : 0);
        }
        //this.router.navigateByUrl('3.108.4.236:8086');
        if (this.CommonReport_Login_Link) {
            window.open(this.CommonReport_Login_Link + this.unitInfo.uvalue + '/' + this.unitInfo.AES_DEC + '/' + this.unitInfo.Unit_ID + '/' + this.unitInfo.CurrentFYear, "_blank");
        } else {
            this.router.navigateByUrl('/reports/commonreports');
        }

    }

    OnConsToSaleClick() {
        var unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
        var Data = {
            Name: unitInfo.Login_Name,
        };
        this.ApiBusy = this.http.post(`/api/${unitInfo.Company_Code}/products/ValidateOpen_ConsToSale`, Data)
            .subscribe((response: any) => {

                if (response[0].flag == 0) {
                    this.toastWarningMsg(response[0].msg);
                }
                else {
                    this.router.navigateByUrl('/sales/consignmenttosales');
                }
            })
    }

    OnRestrictedMenuClick(type) {
        //OrderToInvoice - SalesOrdertoinvoice

        var unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
        var Data = {
            "Unit_ID": unitInfo.Unit_ID,
            "UserName": unitInfo.Login_Name,
            "Type": type
        };
        this.ApiBusy = this.http.post(`/api/${unitInfo.Company_Code}/products/OnRestrictedMenuClick`, Data)
            .subscribe((response: any) => {
                if (response[0].flag == 0) {
                    this.toastWarningMsg(response[0].msg);
                } else {
                    if (type == "OrderToInvoice") {
                        this.router.navigateByUrl('/sales/salesordertochallan');
                    }
                    if (type == "MultiCustomerReceipt") {
                        this.router.navigateByUrl('/finances/salesmanreceipt');
                    }
                    if(type == 'AccountClearing'){
                        this.router.navigateByUrl('/finances/accountclearing');
                    }
                }
            })
    }

    OnGetEntryClick() {
        var unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
        var Data = {
            Name: unitInfo.Login_Name,
        };

        this.router.navigateByUrl('/purchase/gateEntry');
    }

    f_ChkNum(p_value) {
        var Num = Number(p_value);
        if (Num) {
            return Num;
        }
        return 0;
    }
}
